import { redirect } from "react-router-dom";

import { requireFeatureFlag, FeatureFlagsUnavailableError } from "src/app/featureFlags";
import { serviceUnavailableResponse } from "../constants";

/**
 * Loader that gates the entire `/json-forms` route tree behind the
 * `enableJsonForms` AppConfig feature flag. Wraps the LOB selector,
 * every per-LOB pre-screen, and the schema-fetch lifecycle UI under
 * one parent route so the gate covers the full tree with one entry.
 *
 * When the flag is disabled the loader redirects to the application home
 * page so legacy claim-intake routes continue to serve traffic without
 * exposing the new flow.
 *
 * When the lookup itself fails the loader returns 503 rather than
 * redirecting, because a silent bounce to home is indistinguishable from
 * the flag being off and strands anyone who deep-linked into the tree.
 */
export const loader = async () => {
  let isEnabled: boolean;
  try {
    isEnabled = await requireFeatureFlag("enableJsonForms");
  } catch (error) {
    if (error instanceof FeatureFlagsUnavailableError) {
      throw serviceUnavailableResponse(
        "We could not confirm which claim intake experience to show you right now. " +
          "Please retry in a few moments."
      );
    }
    throw error;
  }

  return isEnabled ? null : redirect("/");
};
